import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import React from "react";
import { color } from "../shared/styles";
import ExtraFeeIcon from "../shared/svg/ExtraFeeIcon";
import { KpiIcon } from "../shared/svg/KpiIcon";
import CustomerIcon from "../shared/svg/TabIcons/CustomerIcon";
import DashboardIcon from "../shared/svg/TabIcons/DashboardIcon";
import MaterialIcon from "../shared/svg/TabIcons/MaterialIcon";
import MaterialOrderIcon from "../shared/svg/TabIcons/MaterialOrderIcon";
import ProductIcon from "../shared/svg/TabIcons/ProductIcon";
import ProductOrderIcon from "../shared/svg/TabIcons/ProductOrderIcon";
import { UploadIcon } from "../shared/svg/UploadIcon";
import UserGroup from "../shared/svg/UserGroup";
import UserTag from "../shared/svg/UserTag";
import {
    SIDEBAR_ROLE_ACCESS,
    SidebarItemKey,
    SidebarRoleAccessItem,
} from "./sidebarRoleAccess";

export interface LeftNavTab {
    title: string;
    tabList: LeftNavTabContent[];
    isCollapsed?: boolean;
}

export interface LeftNavTabContent extends SidebarRoleAccessItem {
    tabIcon: any;
    isCollapsed?: boolean;
}

const iconFactory = (icon: any) => {
    return React.cloneElement(icon, {
        defaultColor: color.secondary.CHARCOAL,
        selectedColor: color.primary.BLUE_B100,
    });
};

const leftNavTab = (key: SidebarItemKey, icon: any): LeftNavTabContent => ({
    ...SIDEBAR_ROLE_ACCESS[key],
    tabIcon: iconFactory(icon),
});

export const LeftNavTabs = [
    {
        title: "TRANG CHỦ",
        tabList: [
            leftNavTab("dashboard", <DashboardIcon />),
        ],
    },
    {
        title: "QUẢN LÝ SẢN PHẨM",
        tabList: [
            leftNavTab("products", <ProductIcon />),
            leftNavTab("materials", <MaterialIcon />),
            // {
            //     tabIcon: iconFactory(<AddOnIcon />),
            //     label: "Dịch vụ kèm theo",
            // },
            leftNavTab("extraFees", <ExtraFeeIcon />),
        ],
    },
    {
        title: "QUẢN LÝ ĐƠN HÀNG",
        tabList: [
            leftNavTab("saleOrders", <ProductOrderIcon />),
            leftNavTab("materialOrders", <MaterialOrderIcon />),
            leftNavTab("materialRequests", <PostAddOutlinedIcon />),
            leftNavTab("deliveryTrips", <LocalShippingIcon />),
        ],
    },
    {
        title: "QUẢN LÝ KHÁCH HÀNG",
        tabList: [
            leftNavTab("customers", <CustomerIcon />),
            leftNavTab("providers", <UserTag />),
        ],
    },
    {
        title: "QUẢN LÝ NHÂN VIÊN",
        tabList: [
            leftNavTab("users", <UserGroup />),
        ],
    },
    // {
    //     title: "QUẢN LÝ KẾ TOÁN",
    //     tabList: [
    //         {
    //             tabIcon: iconFactory(<ExtraFeeIcon />),
    //             label: "Tài khoản kế toán",
    //         },
    //     ],
    // },
    {
        title: "QUẢN LÝ KHÁC",
        tabList: [
            leftNavTab("kpis", <KpiIcon />),
            leftNavTab("files", <UploadIcon />),
        ],
    },
];
